import { Tabs, Modal, Divider, Input, Typography } from 'antd';
import QRCode from 'qrcode.react';
import { X, Copy, Check } from 'react-feather';

import CodeWrapper from './CodeWrapper';

import './style.scss';
import { useEffect, useState } from 'react';

const { TabPane } = Tabs;
const { Paragraph } = Typography;

const IntegrationModal = ({ open, setOpen, token, form }) => {
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    if (open) {
      const { props, layout, barLayout } = form.getFieldsValue();
      setFormValues(
        JSON.stringify({
          token,
          layout,
          ...(barLayout !== 'classic'
            ? {
                barLayout: {
                  view: 'energized',
                  style: {
                    height: 360,
                  },
                },
              }
            : {}),
          props,
        })
      );
    }
  }, [open]);

  return (
    <Modal
      open={open}
      width={426}
      maskClosable={false}
      closeIcon={<X size={16} color="#242450" />}
      title="Preview on Mobile Web"
      className="integration-modal"
      onCancel={() => setOpen(!open)}
      footer={null}
    >
      <p>Scan for Test & Active Groups with this QR.</p>
      <div className="qr-container">
        <div className="qr-image">
          <QRCode value={window.location.href} size={120} />
        </div>
        <span>Scan the QR Code with your phone.</span>
      </div>
      <Divider />
      <div className="copy-link">
        <span>Copy Link</span>
        <div className="copy-link-input">
          <Input size="large" value={window.location.href} readOnly />
          <Paragraph
            copyable={{
              icon: [
                <div className="copy-wrapper">
                  <Copy size={16} />
                </div>,
                <div className="copy-wrapper">
                  <Check color="#7A4BFF" size={16} />
                </div>,
              ],
              text: window.location.href,
            }}
          />
        </div>
      </div>
      <Divider />
      <Tabs
        defaultActiveKey="1"
        className="integration-tab"
        style={{ padding: 0 }}
      >
        <TabPane tab="Javascript" key="1">
          <CodeWrapper
            text={`<script custom-element="storyly-web" src="https://web-story.storyly.io/v2/storyly-web.js"></script>
              <storyly-web></storyly-web>
              <script>
                  const storylyWeb = document.querySelector('storyly-web');
                  storylyWeb.init(${formValues});
              </script>
          `}
          />
        </TabPane>
        <TabPane tab="React" key="2">
          <p className="code-description">
            Insert storyly-web.js inside your html body.
          </p>
          <CodeWrapper
            text={`<script custom-element="storyly-web" src="https://web-story.storyly.io/v2/storyly-web.js"></script>`}
          />
          <p className="code-description">
            Put below tag to the page where you want to show your stories.
          </p>
          <CodeWrapper rows={1} text="<storyly-web ref={storylyRef} />" />
          <p className="code-description">
            Initialize Storyly in your use LayoutEffect lifecycle event.{' '}
          </p>
          <CodeWrapper
            text={`const storylyRef = useRef();
            useLayoutEffect(() => {
              storylyRef.current.init(${formValues});
            }, []);`}
          />
        </TabPane>
        <TabPane tab="Vue" key="3">
          <p className="code-description">
            Insert storyly-web.js inside your html body.
          </p>
          <CodeWrapper
            text={`<script custom-element="storyly-web" src="https://web-story.storyly.io/v2/storyly-web.js"></script>`}
          />
          <p className="code-description">
            Put below tag to the page where you want to show your stories.
          </p>
          <CodeWrapper
            rows={1}
            text={`<storyly-web ref="storylyWeb"></storyly-web>`}
          />
          <p className="code-description">
            Finally you can initialize Storyly in your mounted lifecycle event
          </p>
          <CodeWrapper
            text={`<script>
              export default {  
                mounted() {
                  this.$refs.storylyWeb.init(${formValues});
                }
              }
              </script>`}
          />
        </TabPane>
        <TabPane tab="Angular" key="4">
          <p className="code-description">
            Storyly is implemented as a web component so you need to enable
            custom elements schema in your configuration.
          </p>
          <CodeWrapper
            text={`@NgModule({
              ...
              schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
            })
             `}
          />
          <p className="code-description">
            Insert storyly-web.js inside your html body.
          </p>
          <CodeWrapper
            text={`<script custom-element="storyly-web" src="https://web-story.storyly.io
            /v2/storyly-web.js"></script>`}
          />
          <p className="code-description">
            Put below tag to the page where you want to show your stories.
          </p>
          <CodeWrapper
            rows={1}
            text="<storyly-web #storylyweb></storyly-web>"
          />
          <p className="code-description">Initialize your component.</p>
          <CodeWrapper
            text={`import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
            @Component({
              ...
            })
            export class AppComponent implements AfterViewInit{
              @ViewChild("storylyweb") storylyWebDom!: ElementRef;
              ngAfterViewInit(){
                this.storylyWebDom.nativeElement.init(${formValues});
              }
            }`}
          />
        </TabPane>
      </Tabs>
    </Modal>
  );
};

export default IntegrationModal;
